module.exports = __webpack_public_path__ + "img/protective_gear6.33173849.png";